import { useState } from 'react';
import { Button, InputField, Modal, Text } from '@consumidor-positivo/aurora';

import { currencyMask } from '@libs/utils/masks/currency';
import { MMUpdateFilterProps } from '../../../types';

import './styles.scss';
type EditExpenseProps = {
  isOpen: boolean;
  monthlyExpense: string;
  toggleModal: () => void;
  onSubmit: (filters: MMUpdateFilterProps) => void;
};
export const EditExpense = ({ isOpen, monthlyExpense, toggleModal, onSubmit }: EditExpenseProps) => {
  const [newValue, setNewValue] = useState<string | undefined>(monthlyExpense);
  const [error, setError] = useState({
    hasError: false,
    message: '',
  });

  function handleChange(value: string) {
    setNewValue(currencyMask(value));
    const numbersOnly = value.match(/\d/g)?.join('') || '';
    const numericValue = parseFloat(numbersOnly) / 100;

    if (numericValue < 10) {
      return setError({
        hasError: true,
        message: 'O valor mínimo para continuar é R$ 10,00.',
      });
    }

    setError((prev) => ({ ...prev, hasError: false }));
  }

  function handleSave() {
    onSubmit({ monthly_expense: newValue });
    toggleModal();
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={toggleModal}
      content={
        <form className="mm-edit-expense">
          <div className="mm-edit-expense__header">
            <Text as="h5" variant="heading-small" weight="bold">
              Mudar valor de gasto mensal
            </Text>
            <Text as="p" variant="body-medium" color="secondary">
              Coloque outros valores para saber o quanto de cashback você vai ter em 1 ano com o cartão.
            </Text>
          </div>
          <div className="mm-edit-expense__content">
            <Text as="label" variant="body-small" color="secondary" weight="semibold">
              Alterar valor de gasto mensal
            </Text>

            <InputField
              value={newValue}
              placeholder="R$ 2.000,00"
              onChange={(e) => handleChange(e.target.value)}
              error={error?.hasError}
              errorMessage={error?.message}
            />
          </div>
          <div className="mm-edit-expense__buttons">
            <Button expand="x" onClick={handleSave} disabled={error.hasError}>
              Atualizar valor
            </Button>
            <Button expand="x" onClick={toggleModal} type="outlined">
              Cancelar
            </Button>
          </div>
        </form>
      }
    ></Modal>
  );
};
